import type { TemplateForAutofill } from '@apps/card/contexts/AutofillContext';
import type { LayerData } from '@apps/card/routes/CardCustomizer/components/Layer.types';
import { MEDIA_SERVICE } from '@apps/card/routes/CardCustomizer/steps/CardDesign/config';

function injectPhotosIntoLayers(layers: Array<LayerData>, images: ReadonlyArray<Readonly<{ url: string }>>): void {
  let imageIndex = 0;
  for (const layer of layers) {
    if (imageIndex >= images.length) break;
    if (layer.type === 'image' && layer.editable) {
      layer.imageData.src = images[imageIndex].url.replace(`${MEDIA_SERVICE}/`, '');
      imageIndex++;
    }
  }
}

export function autofillPhotos(template: TemplateForAutofill, images: ReadonlyArray<Readonly<{ url: string }>>): void {
  if (!template.themeJSON || !images.length) return;
  const { front, back } = template.themeJSON.card;
  injectPhotosIntoLayers([...front.layers, ...(back?.layers ?? [])], images);
}
